import { render, staticRenderFns } from "./joinCommunity.vue?vue&type=template&id=66f7e6c2&scoped=true"
import script from "./joinCommunity.vue?vue&type=script&lang=js"
export * from "./joinCommunity.vue?vue&type=script&lang=js"
import style0 from "./joinCommunity.vue?vue&type=style&index=0&id=66f7e6c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f7e6c2",
  null
  
)

export default component.exports